<div class="fixed inset-0 z-50 flex items-center justify-center p-3 sm:p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in"
  (click)="closeDropdowns()">
  <div
    class="relative w-full max-w-3xl bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-800/50 animate-fade-in-up max-h-[92vh] flex flex-col overflow-hidden"
    (click)="onClickInsideModal($event)">

    <div *ngIf="isLoading()"
      class="absolute inset-0 bg-white/70 dark:bg-slate-900/70 backdrop-blur-xs z-50 flex items-center justify-center rounded-[2rem]">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
    </div>

    <!-- Header -->
    <div class="flex-none px-6 md:px-8 pt-6 pb-4 border-b border-slate-100 dark:border-slate-800">
      <div class="flex items-start justify-between gap-4">
        <div class="flex items-start gap-3 min-w-0">
          <div
            class="w-12 h-12 rounded-2xl bg-gradient-to-br from-amber-400 to-amber-500 text-slate-900 flex items-center justify-center shadow-[0_8px_20px_-6px_rgba(251,191,36,0.55)] shrink-0">
            <span class="material-icons">{{ isCreate ? 'person_add' : 'manage_accounts' }}</span>
          </div>
          <div class="min-w-0">
            <h3 class="text-xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">
              {{ isCreate ? 'สร้างผู้ใช้ใหม่' : 'แก้ไขผู้ใช้' }}
            </h3>
            <p class="text-xs font-medium text-slate-500 dark:text-slate-400 mt-0.5">
              {{ isCreate ? 'กรอกข้อมูลบัญชี สิทธิ์ และลานที่เข้าถึงได้' : (login || displayName || 'อัปเดตข้อมูลบัญชีและสิทธิ์') }}
            </p>
            <p *ngIf="!isCreate && data?.id" class="text-[11px] text-slate-400 mt-1 font-mono">
              ID {{ data?.id }}
            </p>
          </div>
        </div>
        <button type="button" (click)="onClose()"
          class="w-9 h-9 rounded-xl flex items-center justify-center text-slate-400 hover:text-slate-700 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors border-none bg-transparent cursor-pointer shrink-0">
          <span class="material-icons">close</span>
        </button>
      </div>
    </div>

    <!-- Form body -->
    <div class="flex-1 overflow-y-auto custom-scrollbar px-6 md:px-8 py-5 space-y-5">

      <!-- 1. Account profile -->
      <section class="rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50/70 dark:bg-slate-800/40 p-4 md:p-5 space-y-4">
        <div class="flex items-center gap-2">
          <span class="material-icons text-amber-500 text-[20px]">badge</span>
          <h4 class="text-sm font-extrabold text-slate-700 dark:text-slate-200">ข้อมูลบัญชี</h4>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
              Login <span *ngIf="isCreate" class="text-rose-500">*</span>
            </label>
            <div *ngIf="isCreate"
              class="relative flex items-center bg-white dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px] transition-all">
              <span class="absolute left-3 material-icons text-slate-400 text-[20px]">login</span>
              <input type="text" [(ngModel)]="login" placeholder="เช่น somchai หรือ email" name="login"
                class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:ring-0 focus:outline-none placeholder:text-slate-400">
            </div>
            <div *ngIf="!isCreate" class="p-3 bg-white dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700">
              <p class="text-sm font-bold text-slate-700 dark:text-slate-200">{{ login || '—' }}</p>
              <p class="text-[11px] text-slate-400 mt-0.5">ไม่สามารถแก้ไข Login ได้</p>
            </div>
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
              ชื่อที่แสดง <span class="text-rose-500">*</span>
            </label>
            <div
              class="relative flex items-center bg-white dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px] transition-all">
              <span class="absolute left-3 material-icons text-slate-400 text-[20px]">person</span>
              <input type="text" [(ngModel)]="displayName" placeholder="ชื่อ-นามสกุล" name="displayName"
                class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:ring-0 focus:outline-none placeholder:text-slate-400">
            </div>
          </div>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">อีเมล</label>
            <div
              class="relative flex items-center bg-white dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px] transition-all">
              <span class="absolute left-3 material-icons text-slate-400 text-[20px]">mail</span>
              <input type="email" [(ngModel)]="email" placeholder="email@company.com" name="email"
                class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:ring-0 focus:outline-none placeholder:text-slate-400">
            </div>
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">เบอร์โทร</label>
            <div
              class="relative flex items-center bg-white dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px] transition-all">
              <span class="absolute left-3 material-icons text-slate-400 text-[20px]">call</span>
              <input type="tel" [(ngModel)]="phone" placeholder="08xxxxxxxx" name="phone"
                class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:ring-0 focus:outline-none placeholder:text-slate-400">
            </div>
          </div>
        </div>
      </section>

      <!-- 2. Status -->
      <section class="rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50/70 dark:bg-slate-800/40 p-4 md:p-5 space-y-4">
        <div class="flex items-center gap-2">
          <span class="material-icons text-amber-500 text-[20px]">toggle_on</span>
          <h4 class="text-sm font-extrabold text-slate-700 dark:text-slate-200">สถานะการใช้งาน</h4>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <label class="flex items-center gap-3 p-3.5 rounded-xl border cursor-pointer transition-colors bg-white dark:bg-slate-800"
            [ngClass]="active ? 'border-emerald-300 dark:border-emerald-700/60 bg-emerald-50/50 dark:bg-emerald-900/15' : 'border-slate-100 dark:border-slate-700'">
            <input type="checkbox" [(ngModel)]="active" name="active"
              class="rounded border-slate-300 text-amber-500 focus:ring-amber-400" />
            <div>
              <p class="text-sm font-bold text-slate-700 dark:text-slate-200">Active</p>
              <p class="text-[11px] text-slate-400">บัญชีนี้ใช้งานได้</p>
            </div>
          </label>
          <label class="flex items-center gap-3 p-3.5 rounded-xl border cursor-pointer transition-colors bg-white dark:bg-slate-800"
            [ngClass]="cityLoginEnabled ? 'border-amber-300 dark:border-amber-700/50 bg-amber-50/50 dark:bg-amber-900/15' : 'border-slate-100 dark:border-slate-700'">
            <input type="checkbox" [(ngModel)]="cityLoginEnabled" name="cityLoginEnabled"
              class="rounded border-slate-300 text-amber-500 focus:ring-amber-400" />
            <div>
              <p class="text-sm font-bold text-slate-700 dark:text-slate-200">City Login</p>
              <p class="text-[11px] text-slate-400">อนุญาตเข้า Admin</p>
            </div>
          </label>
        </div>

        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">
            จำนวนเครื่องพร้อมกัน
          </label>
          <div
            class="relative flex items-center bg-white dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px] transition-all">
            <span class="absolute left-3 material-icons text-slate-400 text-[20px]">devices</span>
            <input type="text" [(ngModel)]="maxConcurrentSessionsText" placeholder="ว่าง = ใช้ค่า default เช่น 1" name="maxSessions"
              class="w-full h-full pl-10 pr-4 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:ring-0 focus:outline-none placeholder:text-slate-400">
          </div>
        </div>
      </section>

      <!-- 3. Password (create) -->
      <section *ngIf="isCreate" class="rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50/70 dark:bg-slate-800/40 p-4 md:p-5 space-y-4">
        <div class="flex items-center gap-2">
          <span class="material-icons text-amber-500 text-[20px]">lock</span>
          <h4 class="text-sm font-extrabold text-slate-700 dark:text-slate-200">รหัสผ่าน</h4>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <button type="button" (click)="setPasswordMode('self_set')"
            class="text-left px-4 py-3.5 rounded-xl border bg-white dark:bg-slate-800 cursor-pointer transition-all"
            [ngClass]="passwordMode === 'self_set' ? 'border-amber-400 bg-amber-50 dark:bg-amber-900/20 shadow-sm shadow-amber-200/40' : 'border-slate-100 dark:border-slate-700'">
            <p class="text-sm font-bold text-slate-800 dark:text-slate-100">ให้ผู้ใช้ตั้งเอง</p>
            <p class="text-[11px] font-medium text-slate-400 mt-1">ยังไม่ใส่รหัส — ตั้งตอน login ครั้งแรก</p>
          </button>
          <button type="button" (click)="setPasswordMode('admin_set')"
            class="text-left px-4 py-3.5 rounded-xl border bg-white dark:bg-slate-800 cursor-pointer transition-all"
            [ngClass]="passwordMode === 'admin_set' ? 'border-amber-400 bg-amber-50 dark:bg-amber-900/20 shadow-sm shadow-amber-200/40' : 'border-slate-100 dark:border-slate-700'">
            <p class="text-sm font-bold text-slate-800 dark:text-slate-100">แอดมินตั้งให้</p>
            <p class="text-[11px] font-medium text-slate-400 mt-1">ใส่รหัสชั่วคราวตอนนี้</p>
          </button>
        </div>

        <div *ngIf="passwordMode === 'admin_set'" class="space-y-3">
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">รหัสผ่านใหม่</label>
            <div
              class="relative flex items-center bg-white dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
              <span class="absolute left-3 material-icons text-slate-400 text-[20px]">password</span>
              <input [type]="showCreatePassword ? 'text' : 'password'" [(ngModel)]="password" placeholder="รหัสผ่านใหม่" name="password"
                class="w-full h-full pl-10 pr-11 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:ring-0 focus:outline-none placeholder:text-slate-400">
              <button type="button" (click)="showCreatePassword = !showCreatePassword"
                class="absolute right-2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 border-none bg-transparent cursor-pointer">
                <span class="material-icons text-[20px]">{{ showCreatePassword ? 'visibility_off' : 'visibility' }}</span>
              </button>
            </div>
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ยืนยันรหัสผ่าน</label>
            <div
              class="relative flex items-center bg-white dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
              <span class="absolute left-3 material-icons text-slate-400 text-[20px]">password</span>
              <input [type]="showCreateConfirmPassword ? 'text' : 'password'" [(ngModel)]="confirmPassword" placeholder="ยืนยันรหัสผ่าน" name="confirmPassword"
                class="w-full h-full pl-10 pr-11 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:ring-0 focus:outline-none placeholder:text-slate-400">
              <button type="button" (click)="showCreateConfirmPassword = !showCreateConfirmPassword"
                class="absolute right-2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 border-none bg-transparent cursor-pointer">
                <span class="material-icons text-[20px]">{{ showCreateConfirmPassword ? 'visibility_off' : 'visibility' }}</span>
              </button>
            </div>
          </div>
          <label class="flex items-center gap-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 cursor-pointer">
            <input type="checkbox" [(ngModel)]="mustChangePassword" name="mustChangePassword"
              class="rounded border-slate-300 text-amber-500 focus:ring-amber-400" />
            บังคับเปลี่ยนรหัสครั้งแรก
          </label>
        </div>
      </section>

      <!-- 3b. Password reset (edit) -->
      <section *ngIf="!isCreate" class="rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50/70 dark:bg-slate-800/40 p-4 md:p-5 space-y-4">
        <div class="flex items-center justify-between gap-3 flex-wrap">
          <div class="flex items-center gap-2">
            <span class="material-icons text-amber-500 text-[20px]">lock_reset</span>
            <h4 class="text-sm font-extrabold text-slate-700 dark:text-slate-200">ตั้ง / รีเซ็ตรหัสผ่าน</h4>
          </div>
          <span class="text-[11px] font-bold px-2.5 py-1 rounded-full"
            [ngClass]="hasCityPassword ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/20 dark:text-emerald-400' : 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400'">
            {{ hasCityPassword ? 'มีรหัสแล้ว' : 'ยังไม่ตั้งรหัส' }}
          </span>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <button type="button" (click)="setResetPasswordMode('self_set')"
            class="text-left px-4 py-3.5 rounded-xl border bg-white dark:bg-slate-800 cursor-pointer transition-all"
            [ngClass]="resetPasswordMode === 'self_set' ? 'border-amber-400 bg-amber-50 dark:bg-amber-900/20' : 'border-slate-100 dark:border-slate-700'">
            <p class="text-sm font-bold text-slate-800 dark:text-slate-100">ล้างรหัส — ให้ตั้งเอง</p>
            <p class="text-[11px] text-slate-400 mt-1">ผู้ใช้ตั้งรหัสใหม่ตอนเข้าสู่ระบบ</p>
          </button>
          <button type="button" (click)="setResetPasswordMode('admin_set')"
            class="text-left px-4 py-3.5 rounded-xl border bg-white dark:bg-slate-800 cursor-pointer transition-all"
            [ngClass]="resetPasswordMode === 'admin_set' ? 'border-amber-400 bg-amber-50 dark:bg-amber-900/20' : 'border-slate-100 dark:border-slate-700'">
            <p class="text-sm font-bold text-slate-800 dark:text-slate-100">ตั้งรหัสใหม่ให้</p>
            <p class="text-[11px] text-slate-400 mt-1">แอดมินกำหนดรหัสชั่วคราว</p>
          </button>
        </div>

        <div *ngIf="resetPasswordMode === 'admin_set'" class="space-y-3">
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">รหัสผ่านใหม่</label>
            <div
              class="relative flex items-center bg-white dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
              <span class="absolute left-3 material-icons text-slate-400 text-[20px]">password</span>
              <input [type]="showResetPassword ? 'text' : 'password'" [(ngModel)]="resetPassword" placeholder="รหัสผ่านใหม่" name="resetPassword"
                class="w-full h-full pl-10 pr-11 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:ring-0 focus:outline-none placeholder:text-slate-400">
              <button type="button" (click)="showResetPassword = !showResetPassword"
                class="absolute right-2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 border-none bg-transparent cursor-pointer">
                <span class="material-icons text-[20px]">{{ showResetPassword ? 'visibility_off' : 'visibility' }}</span>
              </button>
            </div>
          </div>
          <div>
            <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ยืนยันรหัสผ่าน</label>
            <div
              class="relative flex items-center bg-white dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 h-[46px]">
              <span class="absolute left-3 material-icons text-slate-400 text-[20px]">password</span>
              <input [type]="showResetConfirmPassword ? 'text' : 'password'" [(ngModel)]="resetConfirmPassword" placeholder="ยืนยันรหัสผ่าน" name="resetConfirmPassword"
                class="w-full h-full pl-10 pr-11 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:ring-0 focus:outline-none placeholder:text-slate-400">
              <button type="button" (click)="showResetConfirmPassword = !showResetConfirmPassword"
                class="absolute right-2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 border-none bg-transparent cursor-pointer">
                <span class="material-icons text-[20px]">{{ showResetConfirmPassword ? 'visibility_off' : 'visibility' }}</span>
              </button>
            </div>
          </div>
          <label class="flex items-center gap-2.5 text-sm font-medium text-slate-600 dark:text-slate-300 cursor-pointer">
            <input type="checkbox" [(ngModel)]="resetMustChangePassword" name="resetMustChangePassword"
              class="rounded border-slate-300 text-amber-500 focus:ring-amber-400" />
            บังคับเปลี่ยนรหัสครั้งถัดไป
          </label>
        </div>

        <div class="flex justify-end">
          <button type="button" (click)="onResetPassword()" [disabled]="isResettingPassword()"
            class="px-4 py-2.5 bg-slate-800 dark:bg-slate-700 hover:bg-slate-900 text-white text-sm font-bold rounded-xl cursor-pointer border-none disabled:opacity-50">
            {{ isResettingPassword() ? 'กำลังบันทึก...' : 'บันทึกรหัสผ่าน' }}
          </button>
        </div>
      </section>

      <!-- 4. Role -->
      <section class="rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50/70 dark:bg-slate-800/40 p-4 md:p-5">
        <div class="flex items-center gap-2 mb-4">
          <span class="material-icons text-amber-500 text-[20px]">admin_panel_settings</span>
          <h4 class="text-sm font-extrabold text-slate-700 dark:text-slate-200">บทบาท (Role)</h4>
          <span class="text-rose-500 text-sm font-bold">*</span>
        </div>

        <div class="relative">
          <div
            class="relative w-full flex items-center bg-white dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 transition-all overflow-hidden h-[46px]"
            (click)="$event.stopPropagation()">
            <span class="absolute left-3 material-icons text-slate-400">badge</span>
            <input type="text" placeholder="พิมพ์เพื่อค้นหา Role..." [(ngModel)]="searchRoleText" name="searchRole"
              [disabled]="isOptionsLoading()" (focus)="onInputFocus('role')" (blur)="closeDropdowns()"
              class="w-full pl-10 pr-10 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:ring-0 focus:outline-none placeholder:text-slate-400 disabled:opacity-60">
            <button type="button" (click)="toggleDropdown('role', $event)" [disabled]="isOptionsLoading()"
              class="absolute right-2 text-slate-400 hover:text-slate-600 outline-none disabled:opacity-60 border-none bg-transparent cursor-pointer">
              <span class="material-icons text-lg transition-transform duration-200" [class.rotate-180]="openDropdown === 'role'">expand_more</span>
            </button>
          </div>

          <div *ngIf="openDropdown === 'role'" (mousedown)="$event.preventDefault()" (click)="$event.stopPropagation()"
            class="absolute top-full left-0 mt-2 w-full bg-white dark:bg-slate-800 rounded-2xl shadow-2xl border border-slate-100 dark:border-slate-700 max-h-48 overflow-y-auto z-45 py-2 custom-scrollbar">
            <div *ngFor="let opt of filteredRoleOptions" (click)="selectRole(opt)"
              class="px-4 py-2 text-sm font-semibold hover:bg-amber-50 dark:hover:bg-amber-900/10 cursor-pointer transition-colors flex items-center justify-between"
              [ngClass]="cpRole === opt.id ? 'text-amber-500 bg-amber-50 dark:bg-amber-900/10' : 'text-slate-600 dark:text-slate-300'">
              {{ opt.name }}
              <span *ngIf="cpRole === opt.id" class="material-icons text-sm">check</span>
            </div>
            <div *ngIf="filteredRoleOptions.length === 0" class="px-4 py-3 text-xs text-slate-400 text-center font-bold">ไม่พบข้อมูล Role</div>
          </div>
        </div>
      </section>

      <!-- 5. Sites -->
      <section class="rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50/70 dark:bg-slate-800/40 p-4 md:p-5 space-y-3">
        <div class="flex items-center justify-between gap-3 flex-wrap">
          <div class="flex items-center gap-2">
            <span class="material-icons text-amber-500 text-[20px]">local_parking</span>
            <h4 class="text-sm font-extrabold text-slate-700 dark:text-slate-200">ลานที่เข้าถึงได้</h4>
          </div>
          <span class="text-[11px] font-bold px-2.5 py-1 rounded-full bg-amber-50 text-amber-700 dark:bg-amber-900/20 dark:text-amber-400">
            เลือกแล้ว {{ selectedSiteCount }} ลาน
          </span>
        </div>
        <p class="text-xs text-slate-500 dark:text-slate-400">ติ๊กเพื่อกำหนดสิทธิ์ลานของผู้ใช้</p>

        <div *ngIf="isSitesLoading()" class="text-xs text-slate-400 py-4">กำลังโหลดรายการลาน...</div>

        <div *ngIf="!isSitesLoading()" class="space-y-2">
          <div class="relative">
            <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-lg">search</span>
            <input type="text" [(ngModel)]="searchSiteText" placeholder="ค้นหาลาน..." name="searchSite"
              class="w-full pl-10 pr-4 h-[46px] rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-amber-200" />
          </div>

          <div class="max-h-48 overflow-y-auto rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 divide-y divide-slate-100 dark:divide-slate-700 custom-scrollbar">
            <label *ngFor="let s of filteredSiteOptions"
              class="flex items-center gap-3 px-4 py-2.5 cursor-pointer hover:bg-amber-50/40 dark:hover:bg-slate-700/40">
              <input type="checkbox" [checked]="isSiteSelected(s.id)" (change)="toggleSite(s.id)"
                class="rounded border-slate-300 text-amber-500 focus:ring-amber-400" />
              <span class="text-sm text-slate-700 dark:text-slate-200">{{ s.name }}</span>
              <span class="ml-auto text-[11px] font-mono text-slate-400">#{{ s.id }}</span>
            </label>
            <div *ngIf="siteOptions().length === 0" class="px-4 py-3 text-xs text-slate-400 text-center">ไม่มีลานในระบบ</div>
            <div *ngIf="siteOptions().length > 0 && filteredSiteOptions.length === 0" class="px-4 py-3 text-xs text-slate-400 text-center">
              ไม่พบลานที่ตรงกับ "{{ searchSiteText }}"
            </div>
          </div>
        </div>
      </section>

      <!-- 6. Stamp -->
      <section class="rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50/70 dark:bg-slate-800/40 p-4 md:p-5 space-y-3">
        <div class="flex items-center gap-2">
          <span class="material-icons text-amber-500 text-[20px]">confirmation_number</span>
          <h4 class="text-sm font-extrabold text-slate-700 dark:text-slate-200">สิทธิ์ Stamp</h4>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
          <label class="flex items-start gap-3 p-3.5 rounded-xl border cursor-pointer bg-white dark:bg-slate-800 transition-colors"
            [ngClass]="stampAllowed ? 'border-amber-300 bg-amber-50/50 dark:bg-amber-900/15 dark:border-amber-700/50' : 'border-slate-100 dark:border-slate-700'">
            <input type="checkbox" [(ngModel)]="stampAllowed" name="stampAllowed"
              class="mt-0.5 rounded border-slate-300 text-amber-500 focus:ring-amber-400" />
            <div>
              <p class="text-sm font-bold text-slate-700 dark:text-slate-200">อนุญาตให้ stamp</p>
              <p class="text-[11px] text-slate-400">เปิดสิทธิ์กด stamp</p>
            </div>
          </label>
          <label class="flex items-start gap-3 p-3.5 rounded-xl border cursor-pointer bg-white dark:bg-slate-800 transition-colors"
            [ngClass]="stampRanges ? 'border-amber-300 bg-amber-50/50 dark:bg-amber-900/15 dark:border-amber-700/50' : 'border-slate-100 dark:border-slate-700'">
            <input type="checkbox" [(ngModel)]="stampRanges" name="stampRanges"
              class="mt-0.5 rounded border-slate-300 text-amber-500 focus:ring-amber-400" />
            <div>
              <p class="text-sm font-bold text-slate-700 dark:text-slate-200">ช่วงยกเว้นค่าจอด</p>
              <p class="text-[11px] text-slate-400">ใช้ stamp แบบช่วงเวลา</p>
            </div>
          </label>
          <label class="flex items-start gap-3 p-3.5 rounded-xl border cursor-pointer bg-white dark:bg-slate-800 transition-colors"
            [ngClass]="stampMany ? 'border-amber-300 bg-amber-50/50 dark:bg-amber-900/15 dark:border-amber-700/50' : 'border-slate-100 dark:border-slate-700'">
            <input type="checkbox" [(ngModel)]="stampMany" name="stampMany"
              class="mt-0.5 rounded border-slate-300 text-amber-500 focus:ring-amber-400" />
            <div>
              <p class="text-sm font-bold text-slate-700 dark:text-slate-200">stamp หลายรายการ</p>
              <p class="text-[11px] text-slate-400">กด stamp ได้หลายใบ</p>
            </div>
          </label>
        </div>
      </section>

      <!-- 7. Client access -->
      <section class="rounded-2xl border border-slate-100 dark:border-slate-700 bg-slate-50/70 dark:bg-slate-800/40 p-4 md:p-5 space-y-3">
        <div class="flex items-center gap-2">
          <span class="material-icons text-amber-500 text-[20px]">storefront</span>
          <h4 class="text-sm font-extrabold text-slate-700 dark:text-slate-200">สิทธิ์เข้าถึงร้าน (Card Quota)</h4>
        </div>
        <p class="text-xs text-slate-500 dark:text-slate-400">
          ลานปัจจุบัน: <span class="font-bold text-slate-700 dark:text-slate-200">{{ siteState.selectedSite()?.name || '—' }}</span>
          · ไม่เลือกร้าน = เห็นทุกร้านในลาน
        </p>

        <div *ngIf="!selectedSiteId" class="text-xs text-rose-500 font-semibold">กรุณาเลือกลานจาก Sidebar</div>
        <div *ngIf="isClientAccessLoading()" class="text-xs text-slate-400 py-4">กำลังโหลดรายการร้าน...</div>

        <div *ngIf="selectedSiteId && !isClientAccessLoading()" class="space-y-2">
          <button type="button" (click)="setUnrestrictedAccess()"
            class="w-full text-left px-4 py-2.5 rounded-xl border text-sm font-semibold transition-colors cursor-pointer bg-white dark:bg-slate-800"
            [ngClass]="clientAccessUnrestricted ? 'border-amber-400 bg-amber-50 text-amber-700 dark:bg-amber-900/20 dark:text-amber-300' : 'border-slate-100 dark:border-slate-700 text-slate-600 dark:text-slate-300'">
            ไม่จำกัด — เห็นทุกร้านในลาน
          </button>

          <div class="relative">
            <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-lg">search</span>
            <input type="text" [(ngModel)]="searchClientText" placeholder="ค้นหาร้าน..." name="searchClient"
              class="w-full pl-10 pr-10 h-[46px] rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-amber-200" />
            <button *ngIf="searchClientText" type="button" (click)="clearClientSearch()"
              class="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 border-none bg-transparent cursor-pointer">
              <span class="material-icons text-lg">close</span>
            </button>
          </div>

          <p *ngIf="!clientAccessUnrestricted && selectedClientCount > 0" class="text-xs text-amber-600 dark:text-amber-400 font-semibold">
            เลือกแล้ว {{ selectedClientCount }} ร้าน
          </p>

          <div class="max-h-40 overflow-y-auto rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 divide-y divide-slate-100 dark:divide-slate-700 custom-scrollbar">
            <label *ngFor="let c of filteredSiteClients"
              class="flex items-center gap-3 px-4 py-2.5 cursor-pointer hover:bg-amber-50/40 dark:hover:bg-slate-700/40">
              <input type="checkbox" [checked]="isClientSelected(c.id)" (change)="toggleClient(c.id)"
                class="rounded border-slate-300 text-amber-500 focus:ring-amber-400" />
              <span class="text-sm text-slate-700 dark:text-slate-200">{{ c.name }}</span>
            </label>
            <div *ngIf="siteClients.length === 0" class="px-4 py-3 text-xs text-slate-400 text-center">ไม่มีร้านในลานนี้</div>
            <div *ngIf="siteClients.length > 0 && filteredSiteClients.length === 0" class="px-4 py-3 text-xs text-slate-400 text-center">
              ไม่พบร้านที่ตรงกับ "{{ searchClientText }}"
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- Footer -->
    <div
      class="flex-none flex items-center justify-between gap-3 px-6 md:px-8 py-4 border-t border-slate-100 dark:border-slate-800 bg-white/90 dark:bg-slate-900/90">
      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()"
        class="px-5 py-2.5 border border-slate-200 dark:border-slate-700 hover:border-amber-400 hover:text-amber-600 text-slate-600 dark:text-slate-300 font-bold rounded-xl shadow-sm transition-all active:scale-95 cursor-pointer inline-flex items-center gap-1.5">
        <span class="material-icons text-base">history</span>
        ดูประวัติ
      </button>
      <div class="flex items-center justify-end gap-3 ml-auto">
        <button type="button" (click)="onClose()"
          class="px-5 py-2.5 bg-slate-50 dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-500 dark:text-slate-400 font-bold rounded-xl shadow-sm transition-all active:scale-95 cursor-pointer border-none">
          ยกเลิก
        </button>
        <button type="button" (click)="onSave()"
          class="px-6 py-2.5 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl shadow-lg shadow-amber-400/25 hover:-translate-y-0.5 transition-all active:scale-95 cursor-pointer border-none">
          {{ isCreate ? 'สร้างผู้ใช้' : 'บันทึก' }}
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && data?.id"
  [entityType]="activityEntityTypes.BackofficeUser"
  [entityId]="data!.id"
  title="ประวัติผู้ใช้ Backoffice"
  [subtitle]="'#' + data!.id"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>
